"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TARGET_TYPE = exports.STATION_IDS = exports.SHARED_STATION_IDS = exports.JR_STATION_IDS = exports.JR_PLUS_STATION_IDS = exports.GENERIC_TEACHER_TIP_LOCATIONS = void 0;
const SHARED_STATION_IDS = exports.SHARED_STATION_IDS = {
  TRANSPORTER: 'TRANSPORTER',
  POWER: 'POWER',
  COMMUNICATION: 'COMMUNICATION',
  REPAIRS: 'REPAIRS',
  CREATIVE_CANVAS: 'CREATIVE_CANVAS'
};
const JR_PLUS_STATION_IDS = exports.JR_PLUS_STATION_IDS = {
  ...SHARED_STATION_IDS,
  DEFENSE_PLUS: 'DEFENSE_PLUS',
  TRACTOR_BEAM_PLUS: 'TRACTOR_BEAM_PLUS'
};
const JR_STATION_IDS = exports.JR_STATION_IDS = {
  ...SHARED_STATION_IDS,
  DEFENSE: 'DEFENSE',
  TRACTOR_BEAM: 'TRACTOR_BEAM',
  SCANNING: 'SCANNING'
};
const STATION_IDS = exports.STATION_IDS = {
  ...SHARED_STATION_IDS,
  ...JR_PLUS_STATION_IDS,
  ...JR_STATION_IDS
};
const TARGET_TYPE = exports.TARGET_TYPE = {
  TARGET: 'TARGET',
  ENEMY_SHIP: 'ENEMY_SHIP',
  ASTEROID: 'ASTEROID'
};
const GENERIC_TEACHER_TIP_LOCATIONS = exports.GENERIC_TEACHER_TIP_LOCATIONS = {
  BEFORE_THIS: 'BEFORE_THIS',
  AFTER_THIS: 'AFTER_THIS',
  HIDDEN: 'HIDDEN'
};